import { Box } from '@fairfashion/design-system'
import { styled } from 'styled-components'

export const Tabs = styled(Box)`
  width: 100%;
  background-color: ${(props) => props.theme.colors.grey_5};
  border-radius: 6px;
  padding: 3px;
`

export const Tab = styled(Box)<{ active: boolean }>`
  cursor: pointer;
  width: 50%;
  background-color: ${(props) => (props.active ? 'white' : 'transparent')};
  border-radius: 6px;
  justify-content: center;
  padding: ${(props) =>
    props.theme.spacing['1'] + ' ' + props.theme.spacing['2']};
  box-shadow: ${(props) => (props.active ? props.theme.box_shadow.card : '')};
`

export const List = styled(Box)`
  width: 100%;
  background-color: ${(props) => props.theme.colors.grey_5};
  border-radius: 6px;
  padding: 3px;
`
